import { setSentryUser } from './setSentryUser';

const setOrderUserId = (order, userData, guestId) => {
  const ID = setSentryUser(userData, guestId);
  order.userId = ID;
  return order;
};

export default setOrderUserId;
